import { useState, useEffect, useRef, useCallback } from 'react';
import { MessageSquarePlus, LogOut, LogIn, Menu, X, Zap, Send } from 'lucide-react';
import { API_BASE_URL, API_ENDPOINTS } from './config/api';
import ChatDetail from './components/ChatDetail';
import Landing from './components/Landing';
import './App.css';
import './components/ChatDetail.css';
import AuthPage from './components/AuthPage';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "./components/ui/alert-dialog";

// Logo Component
const PalmerLogo = ({ className = "w-28 h-6" }) => (
  <svg className={className} viewBox="0 0 112 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0.449883 23.994C0.149883 23.994 -0.000117123 23.844 -0.000117123 23.544V0.450017C-0.000117123 0.150017 0.149883 1.74046e-05 0.449883 1.74046e-05H10.8539C11.1419 1.74046e-05 11.3819 0.0960176 11.5739 0.288018L15.1739 3.88802C15.3779 4.09202 15.4799 4.33202 15.4799 4.60802V11.808C15.4799 12.096 15.3779 12.336 15.1739 12.528L11.5739 16.128C11.3819 16.332 11.1419 16.434 10.8539 16.434H6.56988V23.544C6.56988 23.844 6.41988 23.994 6.11988 23.994H0.449883ZM7.57788 10.602C8.38188 10.602 8.95188 10.422 9.28788 10.062C9.63588 9.69002 9.80988 9.07202 9.80988 8.20802C9.80988 7.33202 9.63588 6.71402 9.28788 6.35402C8.95188 5.99402 8.38188 5.81402 7.57788 5.81402C6.78588 5.81402 6.21588 5.99402 5.86788 6.35402C5.53188 6.71402 5.36388 7.33202 5.36388 8.20802C5.36388 9.07202 5.53188 9.69002 5.86788 10.062C6.21588 10.422 6.78588 10.602 7.57788 10.602ZM18.2373 23.994C17.9373 23.994 17.7873 23.844 17.7873 23.544V6.85802C17.7873 6.69002 17.8473 6.51002 17.9673 6.31802L22.2333 0.270017C22.3653 0.0900173 22.5573 1.74046e-05 22.8093 1.74046e-05H28.9473C29.2113 1.74046e-05 29.4033 0.0900173 29.5233 0.270017L33.8073 6.31802C33.9273 6.48602 33.9873 6.66602 33.9873 6.85802V23.544C33.9873 23.844 33.8373 23.994 33.5373 23.994H27.8673C27.5673 23.994 27.4173 23.844 27.4173 23.544V16.236H24.3573V23.544C24.3573 23.844 24.2073 23.994 23.9073 23.994H18.2373ZM25.8873 11.466C26.7633 11.466 27.3813 11.256 27.7413 10.836C28.1133 10.404 28.2993 9.66602 28.2993 8.62202C28.2993 7.57802 28.1133 6.84602 27.7413 6.42602C27.3813 6.00602 26.7633 5.79602 25.8873 5.79602C25.0113 5.79602 24.3873 6.00602 24.0153 6.42602C23.6553 6.84602 23.4753 7.57802 23.4753 8.62202C23.4753 9.66602 23.6553 10.404 24.0153 10.836C24.3873 11.256 25.0113 11.466 25.8873 11.466ZM37.61 23.994C37.31 23.994 37.16 23.844 37.16 23.544V0.450017C37.16 0.150017 37.31 1.74046e-05 37.61 1.74046e-05H43.28C43.58 1.74046e-05 43.73 0.150017 43.73 0.450017V18.288H47.69C47.99 18.288 48.14 18.438 48.14 18.738V23.544C48.14 23.844 47.99 23.994 47.69 23.994H37.61ZM50.9343 23.994C50.6343 23.994 50.4843 23.844 50.4843 23.544V4.24802C50.4843 3.97202 50.5863 3.73202 50.7903 3.52802L54.0123 0.288018C54.2163 0.0960176 54.4563 1.74046e-05 54.7323 1.74046e-05H58.8003C59.0763 1.74046e-05 59.3163 0.0960176 59.5203 0.288018L62.5443 3.33002H63.3903L66.4143 0.288018C66.6183 0.0960176 66.8583 1.74046e-05 67.1343 1.74046e-05H71.1843C71.4603 1.74046e-05 71.7003 0.0960176 71.9043 0.288018L75.1263 3.52802C75.3303 3.73202 75.4323 3.97202 75.4323 4.24802V23.544C75.4323 23.844 75.2823 23.994 74.9823 23.994H69.3123C69.0123 23.994 68.8623 23.844 68.8623 23.544V6.26402H66.2343V23.544C66.2343 23.844 66.0843 23.994 65.7843 23.994H60.1323C59.8323 23.994 59.6823 23.844 59.6823 23.544V6.26402H57.0543V23.544C57.0543 23.844 56.9043 23.994 56.6043 23.994H50.9343ZM79.1296 23.994C78.8296 23.994 78.6796 23.844 78.6796 23.544V0.450017C78.6796 0.150017 78.8296 1.74046e-05 79.1296 1.74046e-05H91.6756C91.9756 1.74046e-05 92.1256 0.150017 92.1256 0.450017V5.25602C92.1256 5.55602 91.9756 5.70602 91.6756 5.70602H85.2496V9.45002H91.2976C91.5976 9.45002 91.7476 9.60002 91.7476 9.90002V14.094C91.7476 14.394 91.5976 14.544 91.2976 14.544H85.2496V18.288H91.6756C91.9756 18.288 92.1256 18.438 92.1256 18.738V23.544C92.1256 23.844 91.9756 23.994 91.6756 23.994H79.1296ZM95.8288 23.994C95.5288 23.994 95.3788 23.844 95.3788 23.544V0.450017C95.3788 0.150017 95.5288 1.74046e-05 95.8288 1.74046e-05H106.071C106.359 1.74046e-05 106.599 0.0780175 106.791 0.234018L110.931 4.33802C111.063 4.45802 111.141 4.56002 111.165 4.64402C111.201 4.72802 111.219 4.86602 111.219 5.05802V9.99002C111.219 10.146 111.141 10.302 110.985 10.458L108.825 12.582L107.637 13.626L109.275 15.894L111.399 20.232C111.447 20.34 111.483 20.448 111.507 20.556C111.543 20.652 111.561 20.772 111.561 20.916V23.544C111.561 23.844 111.411 23.994 111.111 23.994H105.999C105.735 23.994 105.555 23.874 105.459 23.634L102.723 16.002H101.769V23.544C101.769 23.844 101.619 23.994 101.319 23.994H95.8288ZM103.299 10.404C104.103 10.404 104.673 10.218 105.009 9.84602C105.357 9.47402 105.531 8.84402 105.531 7.95602C105.531 7.05602 105.357 6.42002 105.009 6.04802C104.673 5.67602 104.103 5.49002 103.299 5.49002C102.507 5.49002 101.937 5.67602 101.589 6.04802C101.241 6.42002 101.067 7.05602 101.067 7.95602C101.067 8.84402 101.241 9.47402 101.589 9.84602C101.937 10.218 102.507 10.404 103.299 10.404Z"
      fill="#169464" />
  </svg>
);

// Sidebar Component
const Sidebar = ({ isOpen, onClose, conversations, onNewChat, onSelectChat, isAuthenticated, onAuthAction, currentConversationId }) => {
  return (
    <>
      {/* Overlay for mobile */}
      {isOpen && (
        <div
          className="fixed inset-0 z-40 bg-black bg-opacity-50 lg:hidden"
          onClick={onClose}
        />
      )}

      {/* Sidebar */}
      <div className={`
        fixed inset-y-0 left-0 z-50 w-64 h-full
        bg-white border-r border-gray-200
        transform transition-transform duration-300
        lg:translate-x-0 lg:static
        ${isOpen ? 'translate-x-0' : '-translate-x-full'}
      `}>
        {/* Close button for mobile */}
        <button
          onClick={onClose}
          className="lg:hidden absolute top-4 right-4 p-2 rounded-lg hover:bg-gray-100"
        >
          <X className="w-5 h-5" />
        </button>

        <div className="flex flex-col h-full">
          {/* Logo */}
          <div className="flex items-center pt-4 px-7">
            <PalmerLogo />
          </div>

          {/* Conversations List */}
          <div className="flex-1 overflow-y-auto p-4">
            <ul className="space-y-1.5">
              <li>
                <button
                  onClick={onNewChat}
                  className="w-full flex items-center gap-x-3 py-2 px-3 text-sm text-gray-700 rounded-lg hover:bg-gray-100"
                >
                  <MessageSquarePlus className="w-4 h-4" />
                  New chat
                </button>
              </li>

              {conversations.length === 0 ? (
                <li className="px-3 py-2 text-xs text-gray-500">
                  No conversations yet
                </li>
              ) : (
                conversations.map((convo) => {
                  const isSelected = convo.id === currentConversationId;
                  return (
                    <li key={convo.id}>
                      <button
                        onClick={() => onSelectChat(convo.id)}
                        className={`w-full text-left flex items-center gap-x-3 py-2 px-3 text-sm rounded-lg hover:bg-gray-100 ${isSelected ? 'bg-gray-100 font-semibold border-l-4 border-green-500' : 'text-gray-700'}`}
                        title={convo.title}
                      >
                        {convo.title && convo.title.length > 30
                          ? convo.title.substring(0, 30) + '...'
                          : convo.title || 'Untitled conversation'}
                      </button>
                    </li>
                  )
                })
              )}

              <li>
                <button className="w-full flex items-center gap-x-3 py-2 px-3 text-sm text-gray-700 rounded-lg hover:bg-gray-100">
                  <Zap className="w-4 h-4 text-blue-600" />
                  <span className="bg-gradient-to-r from-blue-600 to-violet-600 bg-clip-text text-transparent">
                    Upgrade Plan
                  </span>
                </button>
              </li>
            </ul>
          </div>

          {/* Footer */}
          <div className="mt-auto">
            <div className="py-2.5 px-7">
              <p className="inline-flex items-center gap-x-2 text-xs text-green-600">
                <span className="block w-1.5 h-1.5 rounded-full bg-green-600"></span>
                Active 12,320 people
              </p>
            </div>

            <div className="p-4 border-t border-gray-200">
              <button
                onClick={onAuthAction}
                className="w-full flex justify-between items-center gap-x-3 py-2 px-3 text-sm text-gray-700 rounded-lg hover:bg-gray-100"
              >
                {isAuthenticated ? 'Sign Out' : 'Sign In'}
                {isAuthenticated ? <LogOut className="w-4 h-4" /> : <LogIn className="w-4 h-4" />}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

// Message Component
const Message = ({ message }) => {
  const isUser = message.type === 'prompt';

  if (isUser) {
    return (
      <li className="flex justify-end gap-x-2 sm:gap-x-4">
        <div className="grow text-right space-y-3">
          <div className="inline-block bg-gray-200 rounded-lg p-4 shadow-sm chat-bubble user-chat-bubble">
            <p className="text-sm text-gray-900 whitespace-pre-wrap break-words">{message.text}</p>
          </div>
        </div>
      </li>
    );
  }

  return (
    <li className="flex gap-x-2 sm:gap-x-4">
      <div className="inline-block bg-white border border-teal-400 rounded-lg p-4 space-y-3 max-w-full w-full">
        {message.status === 'sending' ? (
          <p className="text-sm text-gray-600">
            <span className="inline-block animate-pulse">Palmer AI is analysing...</span>
          </p>
        ) : (
          // Ensure rendered HTML wraps on small screens and long words/code blocks don't overflow
          <div className="font-medium text-gray-800 whitespace-pre-wrap break-words chat-message" dangerouslySetInnerHTML={{ __html: message.text }} />
        )}
      </div>
    </li>
  );
};

// Chat Component
const Chat = ({ conversationId, messages, onSendMessage }) => {
  const [inputValue, setInputValue] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const messagesEndRef = useRef(null);

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!inputValue.trim() || isLoading) return;

    const prompt = inputValue.trim();
    setInputValue('');
    setIsLoading(true);

    await onSendMessage(prompt);
    setIsLoading(false);
  };

  return (
    <div className="flex flex-col h-screen">
      {/* Header */}
      <div className="py-10 lg:py-14">
        <div className="max-w-4xl px-4 sm:px-6 lg:px-8 mx-auto text-center">
          <div className="mb-4 flex justify-center items-center">
            <PalmerLogo className="w-28 h-6" />
          </div>
          <h1 className="text-3xl font-black text-gray-800 sm:text-4xl">
            Welcome to Palmer AI
          </h1>
          <p className="mt-3 text-gray-600">
            Your AI-powered sports betting assistant
          </p>
        </div>

        {/* Messages */}
        <ul className="mt-16 space-y-5 max-w-4xl px-4 mx-auto">
          {messages.map((message, idx) => (
            <Message key={message.id || idx} message={message} />
          ))}
          <div ref={messagesEndRef} />
        </ul>
      </div>

      {/* Input Form */}
      <div className="sticky bottom-0 max-w-4xl mx-auto w-full p-3 sm:py-6 bg-white">
        <form onSubmit={handleSubmit} className="relative">
          <input
            type="text"
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            placeholder="Ask me anything..."
            disabled={isLoading}
            className="p-3 sm:p-4 block w-full bg-white border border-teal-400 rounded-lg pr-12 focus:outline-none focus:ring-2 focus:ring-teal-400"
          />
          <div className="absolute top-1/2 right-2 -translate-y-1/2">
            <button
              type="submit"
              disabled={isLoading}
              className="inline-flex shrink-0 justify-center items-center w-8 h-8 rounded-lg text-white bg-green-600 hover:bg-green-500 disabled:opacity-50"
            >
              <Send className="w-3.5 h-3.5" />
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

// Auth Components removed - imported from external file

// Main App Component
function App() {
  // Check if user is already logged in (token exists in localStorage)
  const hasToken = !!localStorage.getItem('token');
  // Derive initial page from URL so /signin and /signup can be accessed directly via URL
  const deriveInitialPage = () => {
    try {
      const path = window.location.pathname || '/';
      if (path.startsWith('/signin')) return 'signin';
      if (path.startsWith('/signup')) return 'signup';
      // If user attempted to open a chat directly in the URL, redirect to signin when not authenticated
      if (path.startsWith('/chat/')) return hasToken ? 'chat' : 'signin';
    } catch (e) {
      // ignore
    }
    return hasToken ? 'chat' : 'signin';
  };

  const [page, setPage] = useState(deriveInitialPage()); // 'chat', 'signin', 'signup', 'landing'
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(hasToken);
  const [currentConversationId, setCurrentConversationId] = useState(null);
  const [conversations, setConversations] = useState([]);
  const [messages, setMessages] = useState([]);
  const [authLoading, setAuthLoading] = useState(false);
  const [authError, setAuthError] = useState('');
  const [userData, setUserData] = useState(null);
  const [selectedChat, setSelectedChat] = useState(null);
  const [showDisclaimer, setShowDisclaimer] = useState(false);
  const [pendingPrompt, setPendingPrompt] = useState('');
  const [disclaimerAccepted, setDisclaimerAccepted] = useState(false);

  // Fetch user data with conversations
  const fetchUserData = useCallback(async (userId) => {
    try {
      const token = localStorage.getItem('token');
      if (!token) {
        console.error('No authentication token found in localStorage');
        throw new Error('No authentication token found');
      }

      console.log('=== FETCH USER DATA START ===');
      console.log('Fetching user data for user_id:', userId);
      console.log('Token exists:', !!token);

      // Backend uses GET with path parameter: users/{user_id}/
      const url = `${API_BASE_URL}${API_ENDPOINTS.USERS}${userId}/`;
      console.log('Full URL:', url);

      const fetchOptions = {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`, // Include token in header if backend uses it
        },
      };

      console.log('Fetch options:', {
        method: fetchOptions.method,
        headers: fetchOptions.headers,
      });
      console.log('Making GET request with path parameter...');
      const response = await fetch(url, fetchOptions);
      console.log('GET request completed, response received');

      console.log('Response status:', response.status);
      console.log('Response ok:', response.ok);

      if (!response.ok) {
        const errorText = await response.text();
        console.error('Response error text:', errorText);
        throw new Error(`Failed to fetch user data: ${response.status} - ${errorText}`);
      }

      const data = await response.json();
      console.log('User data received:', data);
      console.log('=== FETCH USER DATA SUCCESS ===');

      // Update user data
      setUserData(data);
      localStorage.setItem('userData', JSON.stringify(data));

      // Update conversations from API response
      if (data.conversations && Array.isArray(data.conversations)) {
        const formattedConversations = data.conversations.map(conv => ({
          id: conv.id,
          title: conv.title || 'Untitled conversation',
          createdAt: conv.created_at,
          updatedAt: conv.updated_at,
          messageCount: conv.message_count,
        }));
        console.log('Formatted conversations for sidebar:', formattedConversations);
        setConversations(formattedConversations);
      } else {
        console.log('No conversations found in API response');
        setConversations([]);
      }

      return data;
    } catch (error) {
      console.error('Error fetching user data:', error);
      throw error;
    }
  }, []);

  const handleSendMessage = async (prompt, bypassDisclaimer = false) => {
    // Send message either by creating a new chat (if no conversation selected)
    // or by adding to an existing chat.
    try {
      const token = localStorage.getItem('token');
      if (!token) throw new Error('No authentication token found');

      // Intercept for disclaimer on new chat
      if (!currentConversationId && !disclaimerAccepted && !bypassDisclaimer) {
        setPendingPrompt(prompt);
        setShowDisclaimer(true);
        return;
      }

      // Extract user id from stored user object or userData
      let userObj = null;
      try {
        const raw = localStorage.getItem('user');
        if (raw) userObj = JSON.parse(raw);
      } catch (e) {
        // ignore parse errors
      }
      let userId = (userObj && (userObj.id || userObj.user_id || userObj._id)) || (userData && (userData.id || userData.user_id));

      // Fallback: try to decode user_id from JWT token payload if available
      if (!userId) {
        const tk = localStorage.getItem('token');
        if (tk) {
          try {
            const payload = JSON.parse(atob(tk.split('.')[1]));
            userId = payload.user_id || payload.userId || payload.sub || payload.id;
            console.log('Extracted user_id from token payload:', userId);
          } catch (e) {
            console.warn('Failed to decode token payload for user_id fallback', e);
          }
        }
      }

      if (!currentConversationId) {
        // Create a new chat: POST to /chat/add/ with PromptText and UserID
        const url = `${API_BASE_URL}${API_ENDPOINTS.CHAT}add/`;
        // Backend expects { "prompt": "...", "user_id": "<uuid>" }
        const body = {
          prompt: prompt,
          user_id: userId
        };

        // Ensure we have a valid user id before sending
        if (!userId) {
          throw new Error('No user id found in localStorage or userData');
        }

        // Optimistic local message so user sees their prompt immediately
        const userMessage = { id: `user-${Date.now()}`, type: 'prompt', text: prompt, status: 'sent' };
        const aiLoadingMessage = { id: `ai-${Date.now()}`, type: 'response', text: 'Waiting for analysis...', status: 'sending' };
        setMessages(prev => [...prev, userMessage, aiLoadingMessage]);

        const bodyPayload = { prompt: prompt, user_id: userId };
        console.log('Creating new chat, POST body:', bodyPayload, 'url:', url);

        const resp = await fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
          body: JSON.stringify(bodyPayload),
        });

        if (!resp.ok) {
          const errText = await resp.text();
          throw new Error(errText || 'Failed to create chat');
        }

        const data = await resp.json();

        // Expecting the backend to return the created chat object with id and messages
        if (data && data.id) {
          setSelectedChat(data);
          setCurrentConversationId(data.id);
          // update URL
          try { window.history.pushState({}, '', `/chat/${data.id}/`); } catch (e) { }

          // prepend to conversations list so it appears in sidebar
          setConversations(prev => [{ id: data.id, title: data.title || 'Untitled conversation', createdAt: data.created_at, updatedAt: data.updated_at, messageCount: (data.messages || []).length }, ...prev]);

          // If backend returned populated messages, replace local messages area
          if (data.messages && Array.isArray(data.messages)) {
            // Clear the ephemeral messages and let ChatDetail render real messages
            setMessages([]);
          }
        }
      } else {
        // Add to existing chat
        const url = `${API_BASE_URL}${API_ENDPOINTS.CHAT}${currentConversationId}/add/`;
        const body = { prompt };

        // optimistic UI in the standalone messages view
        const userMessage = { id: `user-${Date.now()}`, type: 'prompt', text: prompt, status: 'sent' };
        const aiLoadingMessage = { id: `ai-${Date.now()}`, type: 'response', text: 'Waiting for analysis...', status: 'sending' };
        setMessages(prev => [...prev, userMessage, aiLoadingMessage]);

        const resp = await fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
          body: JSON.stringify(body),
        });

        if (!resp.ok) {
          const errText = await resp.text();
          throw new Error(errText || 'Failed to send message to chat');
        }

        const data = await resp.json();

        // After adding to an existing chat, refresh the selectedChat if it's loaded
        if (selectedChat && selectedChat.id === currentConversationId) {
          // attempt to refresh selected chat from server
          try {
            await fetchChatDetails(currentConversationId);
            setMessages([]);
          } catch (e) {
            // ignore
          }
        }
      }
    } catch (error) {
      console.error('Error sending message:', error);
      // keep messages but mark last ai message as error if present
      setMessages(prev => prev.map(m => m.status === 'sending' ? { ...m, text: 'Failed to send prompt', status: 'error' } : m));
    }
  };

  const handleNewChat = () => {
    console.log('handleNewChat: creating new blank chat view');
    // Clear selected chat so the standalone Chat view (blank) is shown
    setSelectedChat(null);
    setMessages([]);
    setCurrentConversationId(null);
    // update URL to a canonical new-chat path (optional)
    try { window.history.pushState({}, '', `/chat/new/`); } catch (e) { }
    setSidebarOpen(false);
    setDisclaimerAccepted(false);
  };

  const handleDisclaimerConfirm = () => {
    setDisclaimerAccepted(true);
    setShowDisclaimer(false);
    if (pendingPrompt) {
      handleSendMessage(pendingPrompt, true);
      setPendingPrompt('');
    }
  };

  const fetchChatDetails = async (chatId) => {
    try {
      const token = localStorage.getItem('token');
      if (!token) throw new Error('No authentication token found');

      const response = await fetch(
        `${API_BASE_URL}${API_ENDPOINTS.CHAT_BY_ID(chatId)}`,
        {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        }
      );

      if (!response.ok) throw new Error('Failed to fetch chat details');

      const data = await response.json();
      setSelectedChat(data);
      return data;
    } catch (error) {
      console.error('Error fetching chat details:', error);
      throw error;
    }
  };

  const handleSelectChat = async (id) => {
    setCurrentConversationId(id);
    setSidebarOpen(false);
    try {
      // update URL to reflect selected chat without reloading
      try {
        const newPath = `/chat/${id}/`;
        window.history.pushState({}, '', newPath);
      } catch (e) {
        // ignore history push errors
      }
      await fetchChatDetails(id);
    } catch (error) {
      console.error('Error selecting chat:', error);
      // You might want to show an error message to the user here
    }
  };

  const handleAuth = async (credentials) => {
    setAuthLoading(true);
    setAuthError('');

    try {
      // Determine which endpoint to use based on page
      const isSignUp = page === 'signup';
      const url = isSignUp
        ? `${API_BASE_URL}${API_ENDPOINTS.REGISTER}`
        : `${API_BASE_URL}${API_ENDPOINTS.LOGIN}`;

      const requestBody = {
        email: credentials.email,
        password: credentials.password,
      };

      console.log('Making POST request to:', url);
      console.log('Request body:', requestBody);

      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestBody),
      });

      let data;
      try {
        data = await response.json();
      } catch (jsonError) {
        // If response is not JSON, throw a generic error
        throw new Error(`${isSignUp ? 'Sign up' : 'Login'} failed: ${response.status} ${response.statusText}`);
      }

      if (!response.ok) {
        // Handle error response
        throw new Error(data.message || data.error || `${isSignUp ? 'Sign up' : 'Login'} failed: ${response.status}`);
      }

      // Handle signup success - just redirect to signin without expecting a token
      if (isSignUp) {
        console.log('Sign up successful');
        console.log('Full response data:', data);
        setPage('signin');
        return;
      }

      // Handle login success - expect a token
      if (data.token) {
        console.log('Login successful, token received');
        console.log('Full response data:', data);

        // Store token first
        localStorage.setItem('token', data.token);
        console.log('Token stored in localStorage');

        if (data.user) {
          console.log('User object from response:', data.user);
          console.log('User object keys:', Object.keys(data.user));
          localStorage.setItem('user', JSON.stringify(data.user));

          // Extract user_id from user object - check multiple possible fields
          const userId = data.user.id || data.user.user_id || data.user._id;
          console.log('Extracted user_id:', userId);
          console.log('data.user.id:', data.user.id);
          console.log('data.user.user_id:', data.user.user_id);

          if (userId) {
            console.log('About to call fetchUserData with user_id:', userId);
            console.log('fetchUserData function exists:', typeof fetchUserData === 'function');

            // Fetch full user data including conversations
            try {
              const result = await fetchUserData(userId);
              console.log('User data fetched successfully:', result);
            } catch (fetchError) {
              console.error('Failed to fetch user data:', fetchError);
              console.error('Error details:', fetchError.message);
              console.error('Error stack:', fetchError.stack);
              // Don't block auth if user data fetch fails
            }
          } else {
            console.warn('No user_id found in user object. Available keys:', Object.keys(data.user));
            console.warn('Full user object:', JSON.stringify(data.user, null, 2));
          }
        } else {
          console.warn('No user object in response');
          console.warn('Response data keys:', Object.keys(data));
        }

        setIsAuthenticated(true);
        setPage('chat');
      } else {
        throw new Error('No token received from server');
      }
    } catch (error) {
      console.error('Auth error:', error);
      setAuthError(error.message || 'An error occurred. Please try again.');
    } finally {
      setAuthLoading(false);
    }
  };

  const handleAuthAction = async () => {
    if (isAuthenticated) {
      // Call logout endpoint
      try {
        const token = localStorage.getItem('token');
        const url = `${API_BASE_URL}${API_ENDPOINTS.LOGOUT}`;
        console.log('Sending logout request to:', url);
        const resp = await fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            ...(token ? { 'Authorization': `Bearer ${token}` } : {}),
          },
          body: JSON.stringify({}),
        });
        console.log('Logout response status:', resp.status);
        const data = await resp.json();
        console.log('Logout response:', data);
      } catch (err) {
        console.error('Error calling logout endpoint:', err);
      }

      // Then clear token and user info locally
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      localStorage.removeItem('userData');
      setIsAuthenticated(false);
      setPage('signin');
      setMessages([]);
      setCurrentConversationId(null);
      setConversations([]);
      setUserData(null);
    } else {
      setPage('signin');
    }
  };

  // Load user data on app mount if already authenticated
  useEffect(() => {
    const loadUserDataOnMount = async () => {
      if (isAuthenticated) {
        const storedUser = localStorage.getItem('user');
        const storedUserData = localStorage.getItem('userData');

        if (storedUserData) {
          try {
            const userData = JSON.parse(storedUserData);
            setUserData(userData);

            // Update conversations from stored data
            if (userData.conversations && Array.isArray(userData.conversations)) {
              const formattedConversations = userData.conversations.map(conv => ({
                id: conv.id,
                title: conv.title || 'Untitled conversation',
                createdAt: conv.created_at,
                updatedAt: conv.updated_at,
                messageCount: conv.message_count,
              }));
              console.log('Loaded conversations from localStorage:', formattedConversations);
              setConversations(formattedConversations);
            } else {
              console.log('No conversations in stored user data');
              setConversations([]);
            }
          } catch (error) {
            console.error('Error parsing stored user data:', error);
          }
        }

        // Also try to fetch fresh data if we have user info
        if (storedUser) {
          try {
            const user = JSON.parse(storedUser);
            const userId = user.id || user.user_id;
            if (userId) {
              await fetchUserData(userId);
            }
          } catch (error) {
            console.error('Error fetching user data on mount:', error);
          }
        }

        // If the URL contains a chat id like /chat/{id}/, open that chat
        try {
          const pathMatch = window.location.pathname.match(/^\/chat\/([^\/]+)\/?$/);
          if (pathMatch && pathMatch[1]) {
            const chatIdFromUrl = pathMatch[1];
            // attempt to load chat details
            try {
              await fetchChatDetails(chatIdFromUrl);
              setCurrentConversationId(chatIdFromUrl);
            } catch (err) {
              console.error('Failed to load chat from URL:', err);
            }
          }
        } catch (e) {
          // ignore URL parsing errors
        }
      }
    };

    loadUserDataOnMount();
  }, [isAuthenticated, fetchUserData]);

  // Listen to browser navigation (back/forward) to load chat id from URL
  useEffect(() => {
    const onPopState = () => {
      try {
        const pathname = window.location.pathname || '/';

        // If the user navigated to /signin or /signup, show auth page (no link on landing)
        if (pathname.startsWith('/signin')) {
          setPage('signin');
          return;
        }
        if (pathname.startsWith('/signup')) {
          setPage('signup');
          return;
        }

        // If the user navigated to a chat URL but is not authenticated, send them to signin
        if (pathname.startsWith('/chat/') && !isAuthenticated) {
          setPage('signin');
          return;
        }

        // If a chat id is present in the path, attempt to load it
        const pathMatch = pathname.match(/^\/chat\/([^\/]*)\/?$/);
        if (pathMatch && pathMatch[1]) {
          const chatId = pathMatch[1];
          fetchChatDetails(chatId).catch(err => console.error('Failed to fetch chat on popstate', err));
          setCurrentConversationId(chatId);
        }
      } catch (e) {
        // ignore
      }
    };

    window.addEventListener('popstate', onPopState);
    return () => window.removeEventListener('popstate', onPopState);
  }, [fetchChatDetails, isAuthenticated]);

  if (page === 'signin' || page === 'signup') {
    return (
      <AuthPage
        isSignUp={page === 'signup'}
        onSubmit={handleAuth}
        onToggleMode={() => {
          setPage(page === 'signin' ? 'signup' : 'signin');
          setAuthError(''); // Clear error when switching modes
        }}
        isLoading={authLoading}
        error={authError}
      />
    );
  }

  // Show chat page for both authenticated and unauthenticated users
  // Unauthenticated users will see the blank chat and their messages won't be saved
  // until they sign in

  return (
    <div className="flex h-screen overflow-hidden">
      {/* Mobile menu button */}
      <button
        onClick={() => setSidebarOpen(true)}
        className="lg:hidden fixed top-4 left-4 z-30 p-2 bg-white border border-gray-200 rounded-lg"
      >
        <Menu className="w-5 h-5" />
      </button>

      {/* Sidebar */}
      <Sidebar
        isOpen={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
        conversations={conversations}
        onNewChat={handleNewChat}
        onSelectChat={handleSelectChat}
        isAuthenticated={isAuthenticated}
        onAuthAction={handleAuthAction}
        currentConversationId={currentConversationId}
      />

      {/* Main Content */}
      <div className="flex-1 flex flex-col min-w-0 bg-white">
        {/* Mobile Header */}
        <div className="lg:hidden flex items-center p-4 border-b border-gray-200">
          <button
            onClick={() => setSidebarOpen(true)}
            className="p-2 -ml-2 mr-2 rounded-lg hover:bg-gray-100"
          >
            <Menu className="w-6 h-6" />
          </button>
          <span className="font-semibold text-gray-800">Palmer AI</span>
        </div>

        {/* Chat Area */}
        <div className="flex-1 overflow-hidden relative">
          {currentConversationId && selectedChat ? (
            <ChatDetail chat={selectedChat} />
          ) : (
            <Chat
              conversationId={null}
              messages={messages}
              onSendMessage={handleSendMessage}
            />
          )}
        </div>
      </div>

      <AlertDialog open={showDisclaimer} onOpenChange={setShowDisclaimer}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>Important Disclaimer</AlertDialogTitle>
            <AlertDialogDescription>
              Match Predictions are only for today to increase accuracy. Responses are not financial advice. Palmer AI is not responsible for any financial loss resulting from using the platform.
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel onClick={() => setPendingPrompt('')}>Cancel</AlertDialogCancel>
            <AlertDialogAction onClick={handleDisclaimerConfirm}>I Understand</AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>


    </div>
  );
}

export default App;